webpackJsonp([216],{

/***/ 1139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "Vue 中使用谷歌统计 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1954:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1139),
  /* template */
  __webpack_require__(2401),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/vue-google-analytics-288.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] vue-google-analytics-288.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-98e06b74", Component.options)
  } else {
    hotAPI.reload("data-v-98e06b74", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2401:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("使用谷歌统计")]), _vm._v(" "), _c('p', [_vm._v("单页面应用切换时要手动发送页面统计，首先在 "), _c('code', [_vm._v("index.html")]), _vm._v(" 或者  "), _c('code', [_vm._v("main.js")]), _vm._v(" 里引入谷歌统计代码：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("("), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v("("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("i,s,o,g,r,a,m")]), _vm._v(")")]), _vm._v("{i["), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'GoogleAnalyticsObject'")]), _vm._v("]=r;i[r]=i[r]||"), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v("("), _c('span', {
    staticClass: "hljs-params"
  }), _vm._v(")")]), _vm._v("{\n(i[r].q=i[r].q||[]).push("), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("arguments")]), _vm._v(")},i[r].l="), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("1")]), _vm._v("*"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("new")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("Date")]), _vm._v("();a=s.createElement(o),\nm=s.getElementsByTagName(o)["), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v("];a.async="), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("1")]), _vm._v(";a.src=g;m.parentNode.insertBefore(a,m)\n})("), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("window")]), _vm._v(","), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("document")]), _vm._v(","), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'script'")]), _vm._v(","), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'https://www.google-analytics.com/analytics.js'")]), _vm._v(","), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'ga'")]), _vm._v(");\n\nga("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'create'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'UA-yourID'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'auto'")]), _vm._v(")\nga("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'send'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'pageview'")]), _vm._v(") "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 是否要统计着陆页面访问，取决于你的需求，这个不一定需要，会和`router`统计有重复")]), _vm._v("\n\n")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// main.js 里，如果你使用了 vue-router")]), _vm._v("\nrouter.afterEach("), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("to")]), _vm._v(") ")]), _vm._v("{\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("if")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("window")]), _vm._v(".ga) {\n    "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("window")]), _vm._v(".ga("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'set'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'page'")]), _vm._v(", to.fullPath) "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 你可能想根据请求参数添加其他参数，可以修改这里的 to.fullPath")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("window")]), _vm._v(".ga("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'send'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'pageview'")]), _vm._v(")\n  }\n})\n")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-98e06b74", module.exports)
  }
}

/***/ }),

/***/ 731:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1954);

/***/ })

});


// WEBPACK FOOTER //
// 216.982a8842.js